/* eslint-disable camelcase */
export default {
	sharedTitle: "Shared Notes History",
	privateTitle: "Private Notes History",
};
